const initialState = {
	tracker: {
		loading: false,
		error: null,
		loaded: false
	},
	bankList: null,
	beneficiary: null,
	creditor: null,
	payment: null
}

export default (state = initialState, action) => {
	switch (action.type) {
		case 'GET_TRACKER_START':
			return {
				...state,
				tracker: { loading: true, error: null, loaded: false }
			}
		case 'GET_TRACKER_SUCCESS':
			return {
				...state,
				tracker: { loading: false, error: null, loaded: true }
			}
		case 'GET_TRACKER_ERROR':
			return {
				...state,
				tracker: { loading: false, error: action.payload, loaded: false }
			}
		case 'SET_BANK_LIST':
			return {
				...state,
				bankList: action.payload
			}
		case 'SET_CREDITOR':
			return {
				...state,
				creditor: action.payload
			}
		case 'SET_BENEFICIARY':
			return {
				...state,
				beneficiary: action.payload
			}
		case 'SET_PAYMENT':
			return {
				...state,
				payment: action.payload
			}
		default:
			return state
	}
}
